import { Text } from '@kanda-libs/ks-design-library';
import { InfoWorkType, WorkType } from '@kanda-libs/ks-frontend-services';
import AlternateText from 'components/shared/AlternateBoldText';
import TrustpilotBar from 'components/shared/TrustpilotBar';
import { replaceTradingName } from '../helpers';
import { BODY_TEXTS, COPY, SUBBODY_TEXTS } from './constants';
import EnquiryLandingButton from './LandingButton';

export interface EnquiryLandingContentProps {
  onQuoteClick: () => void;
  onEnquiryClick: () => void;
  tradingName: string;
  infoWorkTypes: InfoWorkType[] | undefined;
  workType: WorkType | undefined;
  isLoading: boolean;
}

const EnquiryLandingContent: React.FunctionComponent<EnquiryLandingContentProps> =
  function ({ onQuoteClick, onEnquiryClick, tradingName, isLoading = false }) {
    return (
      <div className="flex flex-col gap-y-4 md:gap-y-6 w-full mb-auto pt-3">
        <Text
          text={
            <h1 className="text-20-24-em md:text-24-28-em text-left">
              {replaceTradingName(COPY.header, tradingName)}
            </h1>
          }
          isLoading={isLoading}
          skeletonProps={{
            height: 28,
          }}
        />
        <AlternateText
          texts={BODY_TEXTS}
          isLoading={isLoading}
          skeletonProps={{
            count: 4,
          }}
          normalClassName="text-14-22 md:text-16-24"
          alternateClassName="text-14-22-em md:text-16-24-em"
        />
        <AlternateText
          texts={SUBBODY_TEXTS}
          isLoading={isLoading}
          skeletonProps={{
            count: 4,
          }}
          normalClassName="text-14-22 md:text-16-24"
          alternateClassName="text-14-22-em md:text-16-24-em"
        />
        <div className="mb-2 md:mb-0" />
        <EnquiryLandingButton
          onClick={onEnquiryClick}
          icon="send"
          text="I am enquiring about a job"
        />
        <EnquiryLandingButton
          onClick={onQuoteClick}
          icon="job"
          text={`I already have a quote from ${tradingName}`}
        />
        <TrustpilotBar wrapperClassName="my-6" />
      </div>
    );
  };

export default EnquiryLandingContent;
